<template>
  <table class="table-front" :class="isChild !== '1' ? 'rootTable' : ''"  part="table-front">
    <tr v-show="isChild !== '1'" part="table-front-header">
      <th width="120">ID</th>
      <th v-for="(subItem, subkey) in accountProperties" :key="subkey">{{subItem[1]}}</th>
    </tr>
    <template v-for="item in items">
      <div :key="item.id" style="display: contents;">
        <tr>
          <td v-bind:style="tableStyle">
            <div>
              <!-- <template v-if="item.childrenNum > 0"> -->
              <template>
                <template v-if="item.loaded">
                  <i v-if="item.open" class='glyph-icon icon-chevron-down' @click="closeChildren(item.id)"></i>
                  <i v-else class='glyph-icon icon-chevron-right' @click="openChildren(item.id)"></i>
                </template>
                <template v-else>
                  <i v-if="item.open" class='glyph-icon icon-chevron-down' @click="closeChildren(item.id)"></i>
                  <i v-else class='glyph-icon icon-chevron-right' @click="getChildren(item.id)"></i>
                </template>

              </template>
              {{item.idM}}
            </div>
          </td>
          <td v-for="(subItem, subkey) in accountProperties" :key="subkey" v-bind:style="tableStyle">
            {{item[subItem[0]]}}
          </td>
        </tr>
        <tr v-if="item.open">
          <td colspan="100" style="padding: 0 !important;">
            <v-online-order-history v-bind:customId="item.id" header-text="Previous orders"></v-online-order-history>
          </td>
        </tr>
<!--        <tr v-if="item.children.length > 0 && item.open">-->
<!--          <td colspan="100" style="padding: 0 !important;">-->
<!--            <table class="table-front table-front-inner">-->
<!--              <tr part="table-front-header">-->
<!--                <th>ID</th>-->
<!--                <th>Date</th>-->
<!--                <th>Accout ID</th>-->
<!--                <th>Status</th>-->
<!--                <th>Payment system</th>-->
<!--                <th>Wallet</th>-->
<!--                <th>Amount</th>-->
<!--                <th>Comission</th>-->
<!--                <th>Paind at</th>-->
<!--                <th>Comment</th>-->
<!--              </tr>-->
<!--              <tr v-for="invoice in item.children" v-bind:key="invoice.id" part="table-front-body">-->
<!--                <td v-for="(invoiceSub , k) in invoice"  v-bind:key="k">-->
<!--                  <template v-if="k === 'status'">-->
<!--                    <span style="line-height: 15px; padding: .3em .6em .3em; font-size: 10px;" v-bind:class="'bs-label ' + (invoiceSub === 'pending' ? 'label-info' : invoiceSub === 'done' ? 'label-success' : invoiceSub === 'canceled' ? 'label-warning' : 'label-danger')">{{invoiceSub}}</span>-->
<!--                  </template>-->
<!--                  <template v-else>-->
<!--                    {{invoiceSub}}-->
<!--                  </template>-->
<!--                </td>-->
<!--              </tr>-->
<!--            </table>-->
<!--          </td>-->
<!--        </tr>-->
      </div>
    </template>
  </table>
</template>

<script>

import VOnlineOrderHistory from "../../v_online_order_history/OnlineOrderHistory";

export default {
  name: "CollapsedTable",
  components: {
    VOnlineOrderHistory
  },
  data() {
    return {
      d: ''
    };
  },
  props: {
    isChild: {
      type: String,
      required: false,
      default: '0'
    },
    items: {
      required: false,
      default: []
    },
    accountProperties: {
      type: Array,
      default: function () {
        return []
      }
    },
  },
  methods: {
    getChildren(id) {
      this.$emit('get_children', id)
    },
    closeChildren(id) {
      this.$emit('close_children', id)
    },
    openChildren(id) {
      this.$emit('open_children', id)
    }
  },
  computed: {
    tableStyle () {
      return {
        width: `${ 100 / (this.accountProperties.length + 1) }%`,
      }
    }
  }
}
</script>

<style>

.table-front {
  width: 100%;
}

.rootTable {
  border-left: 1px solid #E1E8F0;
  border-top: 1px solid #E1E8F0;
}

.table-front div:nth-of-type(odd) tr {
  background-color: #f9f9f9;
}

.table-front th {
  background: #F9FAFE;
  border-right: 1px solid #dfe8f1;
  padding: 10px;
  border-bottom: 3px solid #E1E8F0;
  font-weight: normal;
}

.table-front td {
  border-right: 1px solid #dfe8f1;
  border-bottom: 1px solid #dfe8f1;
  padding: 10px;
  min-width: 20px;
  color: #919FA9;
}

.table-front-inner th {
  border-bottom: 3px solid #E1E8F0;
}

.table-front-inner th,
.table-front-inner td {
  border-right: none;
}

.table-front-inner tr:nth-of-type(odd) {
  background-color: #f9f9f9;
}
.table-front-inner tr:nth-of-type(even) {
  background-color: #FFF;
}

</style>